var map;
var InfoObj = [];

var icons = {
  adoc:{
    icon: 'https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909'
  }
};

var markersOnMap = [
  {
    codestore: 'A03',
    placeName: 'ADOC Plaza Magdalena',
    storeAddress: 'CC Plaza Magdalena, Local 90, 91 y 92, 1a Calle 15-20 Zona 2, Cobán',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '79523994',
    whatsapp: '31516547',
    page: 'https://g.page/r/CYkbboZyV082EBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 15.470041, 
      lng: -90.3847773
    }],
    type: 'adoc'
  },
  {
    codestore: 'A04',
    placeName: 'ADOC Interplaza',
    storeAddress: 'CC Interplaza Xela, Local 126, Quezaltenango',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '77677358',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/cs254ajkD9pWydD4A',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.8625346,
      lng: -91.5502257
    }],
    type: 'adoc'
  },
  {
    codestore: 'A05',
    placeName: 'ADOC Pradera Vistares',
    storeAddress: 'CC Pradera Vistares Local 132, 133 y 134, Nivel 1, Diagonal 19 Av. Petapa 36-01, Zona 12',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '22567897',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5832753,
      lng: -90.5446462
    }],
    type: 'adoc'
  },
  {
    codestore: 'A06',
    placeName: 'ADOC Mundo Maya',
    storeAddress: 'Km. 1 C.C. Metroplaza Mundo Maya, Cd. Satelite L.22 y 24 Flores, Peten',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '78843619',
    whatsapp: '30818744',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 16.9123688,
      lng: -89.8762731
    }],
    type: 'adoc'
  },
   {
    codestore: 'A08',
    placeName: 'ADOC Villa Nueva',
    storeAddress: 'CC Metrocentro Villa Nueva, Calle 16-20, Local L-204, San Miguel Petapa',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '66315063',
    whatsapp: '31516547',
    page: 'https://g.page/r/CRkAJSPayiNEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5142556, 
      lng: -90.576474
    }],
    type: 'adoc'
  },
  {
    codestore: 'A12',
    placeName: 'ADOC Naranjo',
    storeAddress: 'CC Naranjo Mall, 23 Calle 10-00, 2o Nivel, Local L-227 y L-228, Zona 4, Mixco',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22127379',
    whatsapp: '31516547',
    page: 'https://g.page/r/CUQlHm9E_SqOEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.650554, 
      lng: -90.5417971
    }],
    type: 'adoc'
  },
  {
    codestore: 'A15',
    placeName: 'ADOC Oakland',
    storeAddress: 'CC Oakland Mall,Oakland Mall Local #207, Diagonal 6 13-01, Zona 10',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm',
    phone: '31524617',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/g8daQ1u59X7nccWB9',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5987808,
      lng: -90.5074168
    }],
    type: 'adoc'
  },
  {
    codestore: 'A16',
    placeName: 'ADOC Portales',
    storeAddress: 'CC Portales, Km 4.5 3-20, Ctra al Atlantico, Zona 17, Local 226-227',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm',
    phone: '22564334',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/9ZSsUhUuP97aMqx88',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.647994, 
      lng: -90.4823494
    }],
    type: 'adoc'
  },
  {
    codestore: 'A19',
    placeName: 'ADOC La Trinidad',
    storeAddress: 'CC La Trinidad, 1a. C. y 5a. Av "A", Zona 5, Local #24, Retalhuleu',
    schedule: 'Lunes a Domingo: 9:00am a 8:00pm',
    phone: '77717164',
    whatsapp: '31516547',
    page: 'https://goo.gl/maps/ypALzbSu9Ky9fHCA8',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5326882, 
      lng: -91.6810671
    }],
    type: 'adoc'
  },
  {
    codestore: 'A20',
    placeName: 'ADOC Pradera Huehuetenango',
    storeAddress: 'Calzada Kaibil Balam, El Cambote, Zona 11, CC Pradera Huehuetenango 1er Nivel Local 112 y 113',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '30857112',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 15.31154034041816,
      lng: -91.49149732925181
    }],
    type: 'adoc'
  },
  {
    codestore: 'A21',
    placeName: 'ADOC Centro Comercial Los Totonicapán',
    storeAddress: 'Kilómetro 200, ruta nacional 1, Centro comercial Los Altos Local 115 Totonicapán',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '30329098',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.909855610046266, 
      lng: -91.37243543587846
    }],
    type: 'adoc'
  },
  {
    codestore: 'A22',
    placeName: 'ADOC Plaza Teca',
    storeAddress: 'Plaza Teca Coatepeque',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22772277',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.705472660144647, 
      lng: -91.865545071647 
    }],
    type: 'adoc'
  },
   {
    codestore: 'A23',
    placeName: 'ADOC Zacapa',
    storeAddress: '18 Av. y 1a. C, Zona 3, Zacapa, CC Pradera Zacapa, Bo. Nuevo, 1r. Nivel Local L-17',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '77360003',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.9763592, 
      lng: -89.5300823
    }],
    type: 'adoc'
  },
   {
    codestore: 'A24',
    placeName: 'ADOC Pradera Chiquimula',
    storeAddress: 'Centro Pradera Chiquimula',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22772277',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.808008139738096,   
      lng: -89.53261089699468
    }],
    type: 'adoc'
  },
  {
    codestore: 'A27',
    placeName: 'ADOC Galerías Miraflores',
    storeAddress: 'CC Galerías Miraflores, 11 Av 4-22, Local 182, 183 y 184, Zona 11',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm',
    phone: '24748365',
    whatsapp: '31516547',
    page: 'https://g.page/r/CWtCJxsksdktEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6215348,
      lng: -90.5532309
    }],
    type: 'adoc'
  },
  {
    codestore: 'A28',
    placeName: 'ADOC El Encuentro Quiche',
    storeAddress: 'El Encuentro Quiche',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22772277',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 15.022024889284381, 
      lng: -91.15265815851501  
    }],
    type: 'adoc'
  },
  {
    codestore: 'A29',
    placeName: 'ADOC El Frutal',
    storeAddress: 'Centro Comercial El Frutal',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22772277',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.521584676697913,  
      lng: -90.56431221816771
    }],
    type: 'adoc'
  },
    {
    codestore: 'A30',
    placeName: 'ADOC Puerto Barrios',
    storeAddress: 'CC Pradera Puerto Barrios L73B Km 292.5 Carr. Al Atlantico, Puerto Barrios',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '99999999',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 15.697806, 
      lng: -88.587306
    }],
    type: 'adoc'
  },
  {
    codestore: 'A31',
    placeName: 'ADOC El Progreso',
    storeAddress: 'Barrio El Golfo, Calle Principal Guastatoya, El Progreso',
    schedule: 'Lunes a Domingo: 9:00am a 7:00pm',
    phone: '22772277',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.855417, 
      lng: -90.069527
    }],
    type: 'adoc'
  },
  {
    codestore: 'A34',
    placeName: 'ADOC Pradera Escuintla',
    storeAddress: 'CC Pradera Escuintla, 1 Av. 1-40, Zona 3, Local 2, 3 y 4, Escuintla',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '78898134',
    whatsapp: '31516547',
    page: 'https://g.page/r/CTCly4BCfxWuEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.2885765,
      lng: -90.7854123
    }],
    type: 'adoc'
  },
  {
    codestore: 'A35',
    placeName: 'ADOC CC Metroplaza 4 Caminos',
    storeAddress: 'C.C. Metroplaza 4 Caminos, Barrio La Cienega, Zona 7, San Cristobal Totonicapan, L 165 166',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '47939016',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.908306, 
      lng: -91.4484999999999
    }],
    type: 'adoc'
  },
  {
    codestore: 'A36',
    placeName: 'ADOC Plaza Videre',
    storeAddress: '2da Calle, Blvd Vista Hermosa (19-41), Col Vista Hermosa, Zona 15 L 105',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm',
    phone: '47939016',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.591957, 
      lng: -90.491325
    }],
    type: 'adoc'
  },
  {
    codestore: 'A37',
    placeName: 'ADOC El Encuentro Jalapa',
    storeAddress: 'Barrio llano grande calzada José Arturo Mejía Ruano 2-59 Jalapa Local 35 y 36.',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm',
    phone: '30973673',
    whatsapp: '30973673',
    page: 'https://maps.app.goo.gl/M5yeRdiX1BKyG58g6',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6284184, 
      lng: -89.9799892
    }],
    type: 'adoc'
  },
  {
    codestore: 'A39',
    placeName: 'ADOC Antigua Guatemala',
    storeAddress: '5a C. Pte. y 6a Av. Nte. #12, Antigua Guatemala',
    schedule: 'Lunes a Sábado: 9:00am a 7:00pm<br>Domingo: 9:00am a 6:00pm',
    phone: '78328782',
    whatsapp: '31516547',
    page: 'https://g.page/r/CYl-cPICrV0FEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.557193,
      lng: -90.735127
    }],
    type: 'adoc'
  },  
  {
    codestore: 'A56',
    placeName: 'ADOC Pradera Chimaltenango',
    storeAddress: 'CC Pradera Chimaltenango, 7a. C. 2-02, Zona 2, LN 29, Chimaltenango',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '78399826',
    whatsapp: '31516547',
    page: 'https://g.page/r/CR3VSSebUp3HEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6606085,
      lng: -90.8088166
    }],
    type: 'adoc'
  },
  {
    codestore: 'A81',
    placeName: 'ADOC Pradera Xela',
    storeAddress: 'CC La Pradera Xela, Av. Las Américas 7-12, Zona 3, Locales 63-64, Quezaltenango',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '31515247',
    whatsapp: '31516547',
    page: 'https://g.page/r/CQjVUu6fLAptEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.8500556, 
      lng: -91.534432
    }],
    type: 'adoc'
  },
  {
    codestore: 'A85',
    placeName: 'ADOC Plaza Américas',
    storeAddress: 'CC Plaza Américas, Km 158, Ctra. Interamericana Local 44 y 47 a Mazatenango, Suchitepéquez',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br> Viernes y Sábado: 10:00am a 9:00pm',
    phone: '40824169',
    whatsapp: '31516547',
    page: 'https://g.page/r/CRflvYViBDYtEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5347755, 
      lng: -91.4930052
    }],
    type: 'adoc'
  },
  {
    codestore: 'A96',
    placeName: 'ADOC Pradera Concepción',
    storeAddress: 'CC Pradera Concepción, Local 101 y 102, Km 15.5 Ctra. a El Salvador,<br>Finca Condado Concepción, Zona 7, Santa Catarina Pinula',
    schedule: 'Domingo a Jueves: 10:00am a 8:00pm<br>Viernes y Sábado: 10:00am a 9:00pm',
    phone: '66371900',
    whatsapp: '31516547',
    page: 'https://g.page/r/CTYgFdg6w22KEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5540249,
      lng: -90.4533538
    }],
    type: 'adoc'
  },
  {
    codestore: 'A97',
    placeName: 'ADOC Santa Clara',
    storeAddress: 'CC Santa Clara, Km 17.5 Ctra. al Pacífico Bárcenas, Local 113-114, Villa Nueva',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '',
    whatsapp: '31516547',
    page: '',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.5306933,
      lng: -90.5980232
    }],
    type: 'adoc'
  },
  {
    codestore: 'A98',
    placeName: 'ADOC Peri-Roosevelt',
    storeAddress: 'CC Peri-Roosevelt, Zona 11, Local 16',
    schedule: 'Lunes a Sábado: 9:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '49922069',
    whatsapp: '31516547',
    page: 'https://g.page/r/Cd66o4Xp7uWEEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 14.6268824, 
      lng: -90.5552157
    }],
    type: 'adoc'
  }
];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+mapa'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (mapa)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=mapa'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (mapa)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Guatemala" style="width: 6%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Guatemala" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Guatemala" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Guatemala" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Guatemala" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+502'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%"> (502)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=502'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Guatemala" style="width: 6%">(502)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Guatemala" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 14.6215348, lng: -90.5532309};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 15,
    center: {lat: 14.6215348, lng: -90.5532309},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}